import type { ThumbsFeedbackCategory } from './types';

/** Default category chips shown on thumbs-down (5-7 max per UX research) */
export const DEFAULT_NEGATIVE_CATEGORIES: ThumbsFeedbackCategory[] = [
  { id: 'inaccurate', label: 'Inaccurate' },
  { id: 'incomplete', label: 'Incomplete' },
  { id: 'irrelevant', label: 'Irrelevant' },
  { id: 'formatting', label: 'Poor formatting' },
  { id: 'too_verbose', label: 'Too verbose' },
  { id: 'other', label: 'Other' },
];

/** Inline expansion transition duration (ms) */
export const EXPAND_TRANSITION_MS = 200;

/** How long the "Thanks" confirmation shows before auto-dismissing (ms) */
export const THANKS_DISMISS_MS = 3000;

/** Max characters for the optional comment field */
export const MAX_COMMENT_LENGTH = 500;
